import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'

import './index.scss'

import { APPCONFIG } from '../../configs/app'

import { setLanguage, setActiveTab } from '../../reducer'

class AppHeader extends Component {

  static defaultProps = {}

  state = {
    showLanguageMenu: false,
    showTabMenu: false
  }

  componentDidMount () {
    let { pathname = '' } = this.props.location
    let { tab } = APPCONFIG
    let activeTab = 0
    for (let index = 0; index < tab.length; index++) {
      const path = tab[index].path.replace(/\//g, '')
      if (path && pathname.replace(/\//g, '').indexOf(path) === 0) {
        activeTab = index
        break
      }
    }
    this.props.setActiveTab(activeTab)

    let that = this
    document.onclick = function () {
      that.setState({ showLanguageMenu: false, showTabMenu: false })
    }

    that.scrollTop = 0
    let app = document.getElementById('root')
    app.onscroll = function (e) {
      if (that.state.showLanguageMenu || that.state.showTabMenu) that.setState({ showLanguageMenu: false, showTabMenu: false })

      let scrollTop = e.target.scrollTop
      if (scrollTop - that.scrollTop > 0) {
        //向下
        app.classList.add('scroll')
      } else {
        //向上
        app.classList.remove('scroll')
      }
      that.scrollTop = scrollTop
    }
  }

  handleChangeTab (index, path) {
    this.props.setActiveTab(index)
    this.props.history.push(path)
  }

  handleShowLanguageMenu (e) {
    e.stopPropagation()
    let bol = this.state.showLanguageMenu
    this.setState({ showLanguageMenu: !bol })
  }

  handleShowTabMenu (e) {
    e.stopPropagation()
    let bol = this.state.showTabMenu
    this.setState({ showTabMenu: !bol })
  }

  handleChangeLanguage (lang) {
    this.props.setLanguage(lang)
  }

  render () {
    let { lang, activeTab } = this.props
    let { showLanguageMenu, showTabMenu } = this.state
    let { name, logo, tab, contact } = APPCONFIG
    let { location, phone, email, time } = contact
    return (
      <div className='app-header'>
        <div className='header-info flex-align-justify'>
          <div className='flex max-width'>
            <div className='flex-one flex-align'>
              <div className='info-item flex-align' title={location.label[lang]}>
                <span className='iconfont icon-location'></span>
                <span>{location.value[lang]}</span>
              </div>
              <div className='info-item info-hide flex-align' title={phone.label[lang]}>
                <span className='iconfont icon-phone'></span>
                <span>{phone.value[lang]}</span>
              </div>
            </div>
            <div className='info-item info-hide flex-align' title='时间'>
              <span className='iconfont icon-time'></span>
              <span>{time.value[lang]}</span>
            </div>
            <div className='info-item info-hide flex-align' title={email.label[lang]}>
              <span className='iconfont icon-email'></span>
              <span>{email.value[lang]}</span>
            </div>
            <div className='info-item info-language flex-align' title='语言' onClick={this.handleShowLanguageMenu.bind(this)}>
              <span className='iconfont icon-language'></span>
              {lang === 'en' && <span>EN</span>}
              {lang === 'cn' && <span>中文</span>}
              <span className='iconfont icon-arrow-down'></span>
              <div className={`dropdown-menu ${showLanguageMenu ? 'show' : ''}`}>
                <div className={`menu-item flex-align-justify ${lang === 'cn' ? 'active' : ''}`} onClick={this.handleChangeLanguage.bind(this, 'cn')}>中文</div>
                <div className={`menu-item flex-align-justify ${lang === 'en' ? 'active' : ''}`} onClick={this.handleChangeLanguage.bind(this, 'en')}>English</div>
              </div>
            </div>
          </div>
        </div>
        <div className='header-content flex-justify'>
          <div className='content-wrapper flex max-width'>
            <div className='flex-one flex-align'>
              <Link to='/'>
                <img className='header-logo' src={logo} alt={name[lang]} />
              </Link>
            </div>
            <div className='header-tab flex'>
              {
                tab.map((item, index) => {
                  return (
                    <div
                      className={`tab-item flex-align ${activeTab === index ? 'active' : ''}`}
                      key={index}
                      onClick={this.handleChangeTab.bind(this, index, item.path)}
                    >{item[lang]}</div>
                  )
                })
              }
            </div>
            <div className='header-menu flex-align' onClick={this.handleShowTabMenu.bind(this)}>
              <span className='iconfont icon-menu'></span>
              <div className={`dropdown-menu ${showTabMenu ? 'show' : ''}`}>
                {
                  tab.map((item, index) => {
                    return (
                      <div
                        className={`menu-item flex-align-justify ${activeTab === index ? 'active' : ''}`}
                        key={index}
                        onClick={this.handleChangeTab.bind(this, index, item.path)}
                      >{item[lang]}</div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang,
    activeTab: state.app.activeTab
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setLanguage: data => {
      dispatch(setLanguage(data))
    },
    setActiveTab: data => {
      dispatch(setActiveTab(data))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppHeader))
